export enum TrainingPlanRequestTypeEnum {
  NewTrainingPlan = 'NewTrainingPlan',
  UpdateTrainingPlan = 'UpdateTrainingPlan',
  RetireTrainingPlan = 'RetireTrainingPlan',
}
